const PREFIX = 'TOOLS_',
TOGGLE = 'TOGGLE_';

/**
 * @name TOGGLE_COMPARE
 * @const
 * @description Toggles the parameters modal
 */
export const TOGGLE_COMPARE = PREFIX + TOGGLE + 'COMPARE';

/**
 * @name TOGGLE_FILTERS
 * @const
 * @description Toggles the parameters modal
 */
export const TOGGLE_FILTERS = PREFIX + TOGGLE + 'FILTERS';

/**
 * @name TOGGLE_PARAMETERS
 * @const
 * @description Toggles the parameters modal
 */
export const TOGGLE_PARAMETERS = PREFIX + TOGGLE + 'PARAMETERS';